import axios from 'axios';

export const get = () => axios.get('/api/config');
export const getManager = () => axios.get('/api/manager/config');
export const setManager = payload => axios.post('/api/manager/config', payload);
